// Pricing configuration for booth application form.
// boothLevels: e.g., Standard, Premium, VIP; each level can have base price and modifiers.
// corner vs inline pricing handled via an adjustment amount.

export const boothLevels = [
  { id: 'STANDARD', label: 'Standard', basePrice: 1000 },
  { id: 'PREMIUM', label: 'Premium', basePrice: 1400 },
  { id: 'VIP', label: 'VIP', basePrice: 1800 }
];

export const positionTypes = [
  { id: 'INLINE', label: 'Inline', priceAdjust: 0 },
  { id: 'CORNER', label: 'Corner', priceAdjust: 150 }
];

// Example item categories (what the vendor plans to sell) – can be refined or loaded from Firestore later.
export const itemCategories = [
  'Clothing', 'Books', 'Food', 'Jewelry', 'Health/Beauty', 'Toys', 'Services', 'Non-Profit Info', 'Other'
];

export function computeBoothPrice(levelId, positionId) {
  const level = boothLevels.find(l => l.id === levelId);
  const pos = positionTypes.find(p => p.id === positionId);
  if (!level || !pos) return 0;
  return level.basePrice + pos.priceAdjust;
}

export function summarizeApplicationBooths(booths) {
  return booths.reduce((sum, b) => sum + computeBoothPrice(b.level, b.position), 0);
}
